export default {"src":"/_next/static/media/ic-search.416e95ac.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};